"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DefaultLabelGroups = void 0;
var _labels = require("./labels");
var DefaultLabelGroups = exports.DefaultLabelGroups = [{
  groupStyle: 'fixed',
  groupIsVisible: true,
  items: {
    annualLimit: _labels.DefaultLabels.annualLimit,
    levelOfCover: _labels.DefaultLabels.levelOfCover,
    excess: _labels.DefaultLabels.excess,
    routineCare: _labels.DefaultLabels.routineCare,
    dental: _labels.DefaultLabels.dental,
    accidentalInjury: _labels.DefaultLabels.accidentalInjury,
    coversIllness: _labels.DefaultLabels.coversIllness,
    tickParalysis: _labels.DefaultLabels.tickParalysis,
    hipJoints: _labels.DefaultLabels.hipJoints,
    cruciateLigament: _labels.DefaultLabels.cruciateLigament,
    emergencyBoarding: _labels.DefaultLabels.emergencyBoarding,
    consultation: _labels.DefaultLabels.consultation
  }
}, {
  groupStyle: 'showAll',
  groupLabel: 'Show all features',
  groupIsVisible: false,
  showAllButtonCssClass: 'button primary text_only',
  items: {
    waitingPeriods: _labels.DefaultLabels.waitingPeriods,
    preExistingCondition: _labels.DefaultLabels.preExistingCondition,
    gapOnly: _labels.DefaultLabels.gapOnly,
    medicinesDrugs: _labels.DefaultLabels.medicinesDrugs,
    hospitalisation: _labels.DefaultLabels.hospitalisation,
    specialistCare: _labels.DefaultLabels.specialistCare,
    hereditary: _labels.DefaultLabels.hereditary
  }
}];
var _default = exports["default"] = {
  DefaultLabelGroups: DefaultLabelGroups
};